// // export default StepUploadContent;

// import { useState, useEffect } from "react";
// import MDEditor from "@uiw/react-md-editor";

// /* ----------------------- Drive helpers + preview ----------------------- */

// function normalizeUrlList(arr) {
//   if (!Array.isArray(arr)) return [];
//   return arr.map((it) =>
//     typeof it === "string" ? { url: it } : it || { url: "" }
//   );
// }

// function extractDriveId(url = "") {
//   if (!url) return null;
//   return (
//     url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1] ||
//     url.match(/[?&]id=([a-zA-Z0-9_-]+)/)?.[1] ||
//     url.match(/\/uc\?.*?[?&]id=([a-zA-Z0-9_-]+)/)?.[1]
//   );
// }
// function getDrivePreviewUrl(url = "") {
//   const id = extractDriveId(url);
//   return id ? `https://drive.google.com/uc?export=view&id=${id}` : "";
// }
// function DriveImagePreview({ url, size = "md" }) {
//   const [state, setState] = useState("loading");
//   const [src, setSrc] = useState(getDrivePreviewUrl(url));

//   useEffect(() => {
//     const next = getDrivePreviewUrl(url);
//     setSrc(next);
//     setState(next ? "loading" : "error");
//   }, [url]);

//   const handleError = () => {
//     const id = extractDriveId(url);
//     if (id && !src.includes("/thumbnail")) {
//       setSrc(`https://drive.google.com/thumbnail?id=${id}&sz=w1000`);
//       setState("loading");
//     } else {
//       setState("error");
//     }
//   };

//   const cls =
//     size === "sm"
//       ? "w-28 h-28 object-cover rounded border"
//       : "w-full max-w-md max-h-64 object-contain rounded-xl border";

//   if (state === "error") {
//     return (
//       <p className="text-xs text-red-500 mt-1">
//         Couldn’t load the image. Ensure it’s an image file and shared as{" "}
//         <b>“Anyone with the link”</b>.
//       </p>
//     );
//   }

//   return (
//     <img
//       src={src}
//       alt="Preview"
//       className={cls}
//       referrerPolicy="no-referrer"
//       onLoad={() => setState("ok")}
//       onError={handleError}
//       loading="lazy"
//     />
//   );
// }

// /* --------------------------- YouTube helpers --------------------------- */
// function getYouTubeVideoId(url) {
//   if (!url) return null;
//   const reg = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
//   const match = url.match(reg);
//   return match ? match[1] : null;
// }

// /* ============================== Component ============================== */
// export default function StepUploadContent({
//   type,
//   values,
//   onChange,
//   onNext,
//   onBack,
// }) {
//   const isProduct = (type || "").toLowerCase() === "product";

//   console.log("values", values);

//   const normalizedCourseImages = normalizeUrlList(values.courseImages);
//   const normalizedProductImages = normalizeUrlList(
//     values.productImages ?? values.images
//   );

//   useEffect(() => {
//     const needsCourseFix =
//       Array.isArray(values.courseImages) &&
//       values.courseImages.some((x) => typeof x === "string");
//     const needsProductFix =
//       (Array.isArray(values.productImages) &&
//         values.productImages.some((x) => typeof x === "string")) ||
//       (!values.productImages && Array.isArray(values.images)); // migrating from product 'images' array

//     if (needsCourseFix || needsProductFix) {
//       onChange({
//         ...values,
//         courseImages: needsCourseFix
//           ? normalizeUrlList(values.courseImages)
//           : normalizedCourseImages,
//         productImages: needsProductFix
//           ? normalizeUrlList(values.productImages ?? values.images)
//           : normalizedProductImages,
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // run once on mount

//   /* ------------------------ COURSE: Image links (Drive) ------------------------ */
//   const courseImages = normalizedCourseImages;

//   const addCourseImage = () =>
//     onChange({ ...values, courseImages: [...courseImages, { url: "" }] });
//   const changeCourseImage = (i, val) => {
//     const arr = [...courseImages];
//     arr[i] = { ...arr[i], url: val };
//     onChange({ ...values, courseImages: arr });
//   };
//   const removeCourseImage = (i) => {
//     const arr = [...courseImages];
//     arr.splice(i, 1);
//     onChange({ ...values, courseImages: arr });
//   };

//   /* ------------------------ COURSE: Global PDFs ------------------------ */
//   const pdfLinks = Array.isArray(values.pdfLinks) ? values.pdfLinks : [];
//   const handleAddPdfLink = () =>
//     onChange({
//       ...values,
//       pdfLinks: [
//         ...pdfLinks,
//         {
//           url: "",
//           downloadable: false,
//           previewable: false,
//           showFree: false,
//           notes: "",
//         },
//       ],
//     });
//   const handlePdfLinkChange = (i, key, val) => {
//     const arr = [...pdfLinks];
//     arr[i][key] = val;
//     onChange({ ...values, pdfLinks: arr });
//   };
//   const handleRemovePdfLink = (i) => {
//     const arr = [...pdfLinks];
//     arr.splice(i, 1);
//     onChange({ ...values, pdfLinks: arr });
//   };

//   /* ----------------------- COURSE: YouTube links ----------------------- */
//   const ytLinks = Array.isArray(values.youtubeLinks) ? values.youtubeLinks : [];
//   const handleAddLink = () =>
//     onChange({
//       ...values,
//       youtubeLinks: [
//         ...ytLinks,
//         { url: "", showFree: false, notes: "", pdfs: [] },
//       ],
//     });
//   const handleLinkChange = (i, key, val) => {
//     const arr = [...ytLinks];
//     arr[i][key] = val;
//     onChange({ ...values, youtubeLinks: arr });
//   };
//   const handleRemoveLink = (i) => {
//     const arr = [...ytLinks];
//     arr.splice(i, 1);
//     onChange({ ...values, youtubeLinks: arr });
//   };

//   /* --------------- COURSE: PDFs attached to each YT link -------------- */
//   const addYtPdf = (i) => {
//     const arr = [...ytLinks];
//     const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
//     pdfs.push({
//       url: "",
//       downloadable: false,
//       previewable: false,
//       showFree: false,
//       notes: "",
//     });
//     arr[i].pdfs = pdfs;
//     onChange({ ...values, youtubeLinks: arr });
//   };
//   const changeYtPdf = (i, j, key, val) => {
//     const arr = [...ytLinks];
//     const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
//     pdfs[j][key] = val;
//     arr[i].pdfs = pdfs;
//     onChange({ ...values, youtubeLinks: arr });
//   };
//   const removeYtPdf = (i, j) => {
//     const arr = [...ytLinks];
//     const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
//     pdfs.splice(j, 1);
//     arr[i].pdfs = pdfs;
//     onChange({ ...values, youtubeLinks: arr });
//   };

//   /* -------------------------- PRODUCT: Images -------------------------- */
//   const productImages = normalizedProductImages.map((img, idx, all) => {
//     // ensure isMain exists (default: first item if none)
//     if (typeof img.isMain !== "boolean") {
//       const hasAnyMain = all.some((x) => x && x.isMain);
//       return { ...img, isMain: hasAnyMain ? !!img.isMain : idx === 0 };
//     }
//     return img;
//   });

//   const addProductImage = () => {
//     const next = [
//       ...productImages,
//       { url: "", isMain: productImages.length === 0 },
//     ];
//     onChange({ ...values, productImages: next });
//   };

//   const changeProductImage = (i, key, val) => {
//     const arr = [...productImages];
//     arr[i] = { ...arr[i], [key]: val };
//     onChange({ ...values, productImages: arr });
//   };

//   const removeProductImage = (i) => {
//     const arr = [...productImages];
//     const removed = arr.splice(i, 1)[0];
//     if (removed?.isMain && arr.length > 0 && !arr.some((x) => x.isMain)) {
//       arr[0].isMain = true;
//     }
//     onChange({ ...values, productImages: arr });
//   };

//   const setMainProductImage = (i) => {
//     const arr = productImages.map((img, idx) => ({
//       ...img,
//       isMain: idx === i,
//     }));
//     onChange({ ...values, productImages: arr });
//   };

//   /* -------------------- PRODUCT: Descriptions / YT -------------------- */
//   const productMainDesc = values.productMainDesc || "";
//   const productSubDescs = Array.isArray(values.productSubDescs)
//     ? values.productSubDescs
//     : [];
//   const productYtLinks = Array.isArray(values.productYoutubeLinks)
//     ? values.productYoutubeLinks
//     : [];

//   const changeMainDesc = (val) =>
//     onChange({ ...values, productMainDesc: val || "" });
//   const addSubDesc = () =>
//     onChange({ ...values, productSubDescs: [...productSubDescs, ""] });
//   const changeSubDesc = (i, val) => {
//     const arr = [...productSubDescs];
//     arr[i] = val;
//     onChange({ ...values, productSubDescs: arr });
//   };
//   const removeSubDesc = (i) => {
//     const arr = [...productSubDescs];
//     arr.splice(i, 1);
//     onChange({ ...values, productSubDescs: arr });
//   };

//   const addProductYt = () =>
//     onChange({
//       ...values,
//       productYoutubeLinks: [...productYtLinks, { url: "", notes: "" }],
//     });
//   const changeProductYt = (i, key, val) => {
//     const arr = [...productYtLinks];
//     arr[i][key] = val;
//     onChange({ ...values, productYoutubeLinks: arr });
//   };
//   const removeProductYt = (i) => {
//     const arr = [...productYtLinks];
//     arr.splice(i, 1);
//     onChange({ ...values, productYoutubeLinks: arr });
//   };

//   /* ----------------------------- Validate ----------------------------- */
//   function handleNext(e) {
//     e.preventDefault();

//     if (isProduct) {
//       if (productImages.length === 0) {
//         alert("Please add at least one product image.");
//         return;
//       }
//       if (!productImages.some((img) => img.isMain)) {
//         alert("Please select a main image.");
//         return;
//       }
//       if (!productMainDesc || productMainDesc.trim() === "") {
//         alert("Please add a main description for your product.");
//         return;
//       }
//       onNext();
//       return;
//     }

//     // Course: at least one PDF (global or per-video)
//     const totalGlobal = pdfLinks.length;
//     const totalVideo = ytLinks.reduce(
//       (sum, l) => sum + (Array.isArray(l.pdfs) ? l.pdfs.length : 0),
//       0
//     );
//     if (totalGlobal + totalVideo === 0) {
//       alert("Please add at least one PDF (global or attached to a video).");
//       return;
//     }
//     onNext();
//   }

//   /* ------------------------------ Render ------------------------------ */
//   return (
//     <div className="max-h-[80vh] overflow-y-auto">
//       <form className="flex flex-col gap-6" onSubmit={handleNext}>
//         {!isProduct ? (
//           <>
//             {/* ================= COURSE: IMAGE LINKS (Google Drive) ================= */}
//             <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
//               <span className="text-lg font-bold mb-1 block">
//                 Course Images (Student reviews, Student Feedbacks, Sample
//                 Images) (Google Drive)
//               </span>
//               <span className="text-sm text-blue-700 mb-2 block">
//                 Add any number of image links from Google Drive. Set each file’s
//                 sharing to <b>“Anyone with the link”</b>.
//               </span>

//               {courseImages.map((img, i) => (
//                 <div
//                   key={i}
//                   className="w-full bg-white rounded-xl px-4 py-3 mt-3 shadow"
//                 >
//                   <div className="flex items-center gap-3">
//                     <input
//                       type="url"
//                       className="flex-1 p-2 border rounded-xl"
//                       placeholder="https://drive.google.com/file/d/..."
//                       value={img.url}
//                       onChange={(e) =>
//                         changeCourseImage(i, e.target.value.trim())
//                       }
//                       required
//                     />
//                     <button
//                       type="button"
//                       onClick={() => removeCourseImage(i)}
//                       className="text-red-400 hover:bg-red-100 rounded-full p-2 text-lg"
//                       title="Remove image"
//                     >
//                       ×
//                     </button>
//                   </div>
//                   {img.url ? (
//                     <DriveImagePreview url={img.url} size="sm" />
//                   ) : null}
//                 </div>
//               ))}

//               <button
//                 type="button"
//                 className="mt-4 px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
//                 onClick={addCourseImage}
//               >
//                 + Add Image
//               </button>
//             </div>
//             {/* ================= COURSE: GLOBAL GOOGLE DRIVE PDFs ================= */}
//             <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
//               <span className="text-lg font-bold mb-1 block">
//                 Add PDF Links (Google Drive)
//               </span>
//               <span className="text-sm text-blue-700 mb-2 block">
//                 Paste your PDF file link from Google Drive. Set file sharing to
//                 "Anyone with the link". Choose if each PDF is <b>Free</b> or
//                 shown <b>After Paid</b>.
//               </span>

//               {pdfLinks.map((p, i) => (
//                 <div
//                   key={i}
//                   className="w-full flex flex-col items-start gap-2 bg-white rounded-xl px-6 py-4 mt-3 shadow"
//                 >
//                   <div className="flex items-center gap-4 w-full">
//                     <input
//                       type="url"
//                       className="flex-1 p-2 border rounded-xl"
//                       placeholder="https://drive.google.com/file/d/..."
//                       value={p.url}
//                       onChange={(e) =>
//                         handlePdfLinkChange(i, "url", e.target.value)
//                       }
//                       required
//                     />

//                     {/* Downloadable / Preview */}
//                     <label className="flex items-center gap-1 text-xs whitespace-nowrap">
//                       <input
//                         type="radio"
//                         name={`pdfOption-${i}`}
//                         checked={!!p.downloadable}
//                         onChange={() => {
//                           handlePdfLinkChange(i, "downloadable", true);
//                           handlePdfLinkChange(i, "previewable", false);
//                         }}
//                         className="accent-blue-600"
//                       />
//                       Downloadable
//                     </label>
//                     <label className="flex items-center gap-1 text-xs whitespace-nowrap">
//                       <input
//                         type="radio"
//                         name={`pdfOption-${i}`}
//                         checked={!!p.previewable}
//                         onChange={() => {
//                           handlePdfLinkChange(i, "previewable", true);
//                           handlePdfLinkChange(i, "downloadable", false);
//                         }}
//                         className="accent-green-600"
//                       />
//                       Preview on site
//                     </label>

//                     {/* Free / Paid */}
//                     <label className="flex items-center gap-1 text-xs whitespace-nowrap ml-2">
//                       <input
//                         type="radio"
//                         name={`pdfAccess-${i}`}
//                         checked={!!p.showFree}
//                         onChange={() =>
//                           handlePdfLinkChange(i, "showFree", true)
//                         }
//                         className="accent-blue-600"
//                       />
//                       Free
//                     </label>
//                     <label className="flex items-center gap-1 text-xs whitespace-nowrap">
//                       <input
//                         type="radio"
//                         name={`pdfAccess-${i}`}
//                         checked={!p.showFree}
//                         onChange={() =>
//                           handlePdfLinkChange(i, "showFree", false)
//                         }
//                         className="accent-green-600"
//                       />
//                       After Paid
//                     </label>

//                     <button
//                       type="button"
//                       onClick={() => handleRemovePdfLink(i)}
//                       className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1 text-lg"
//                       title="Remove PDF Link"
//                     >
//                       ×
//                     </button>
//                   </div>

//                   <div className="w-full mt-1 text-left">
//                     <label className="font-semibold text-xs mb-1 block">
//                       Notes
//                     </label>
//                     <MDEditor
//                       value={p.notes || ""}
//                       onChange={(val) => handlePdfLinkChange(i, "notes", val)}
//                       height={120}
//                       placeholder="Add notes, instructions, etc."
//                     />
//                   </div>
//                 </div>
//               ))}

//               <button
//                 type="button"
//                 className="mt-4 px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
//                 onClick={handleAddPdfLink}
//               >
//                 + Add PDF Link
//               </button>
//             </div>

//             {/* ================= COURSE: YOUTUBE LINKS (+ PDFs per video) ================= */}
//             <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-2xl p-4 mb-6">
//               <div className="font-bold text-lg mb-2">YouTube Links</div>

//               {ytLinks.map((link, i) => {
//                 const vid = getYouTubeVideoId(link.url);
//                 const ytThumb = vid
//                   ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
//                   : null;
//                 const pdfs = Array.isArray(link.pdfs) ? link.pdfs : [];

//                 return (
//                   <div
//                     key={i}
//                     className="flex flex-col gap-3 bg-white rounded-xl px-4 py-3 mb-3 shadow-sm"
//                   >
//                     {/* <div className=""> */}
//                     <label className="font-semibold text-xs block">Topic</label>
//                     <input
//                       value={link.topic}
//                       placeholder="Topic"
//                       onChange={(e) =>
//                         handleLinkChange(i, "topic", e.target.value)
//                       }
//                       className="flex-1 p-2 border rounded-xl bg-white"
//                     />
//                     {/* </div> */}
//                     <label className="font-semibold text-xs mt-2 block">
//                       Youtube Link
//                     </label>
//                     <div className="flex items-center gap-2 w-full">
//                       <input
//                         className="flex-1 p-2 border rounded-xl bg-white"
//                         placeholder="https://youtube.com/..."
//                         value={link.url}
//                         onChange={(e) =>
//                           handleLinkChange(i, "url", e.target.value)
//                         }
//                       />
//                       <label className="flex items-center gap-1 ml-2">
//                         <input
//                           type="radio"
//                           checked={!!link.showFree}
//                           onChange={() => handleLinkChange(i, "showFree", true)}
//                           className="accent-blue-600"
//                         />
//                         Free
//                       </label>
//                       <label className="flex items-center gap-1 ml-1">
//                         <input
//                           type="radio"
//                           checked={!link.showFree}
//                           onChange={() =>
//                             handleLinkChange(i, "showFree", false)
//                           }
//                           className="accent-green-600"
//                         />
//                         After Paid
//                       </label>
//                       {ytThumb ? (
//                         <img
//                           src={ytThumb}
//                           alt="YT Thumb"
//                           className="w-10 h-10 object-cover rounded border"
//                         />
//                       ) : (
//                         <span className="ml-2 text-blue-400 text-xs">
//                           No thumbnail
//                         </span>
//                       )}
//                       <button
//                         type="button"
//                         className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1"
//                         title="Remove link"
//                         onClick={() => handleRemoveLink(i)}
//                       >
//                         ×
//                       </button>
//                     </div>

//                     <div className="w-full">
//                       <label className="font-semibold text-xs mb-1 block">
//                         Notes
//                       </label>
//                       <MDEditor
//                         value={link.notes || ""}
//                         onChange={(val) => handleLinkChange(i, "notes", val)}
//                         height={100}
//                         placeholder="Add video notes, key points, etc."
//                       />
//                     </div>

//                     {/* PDFs attached to this video */}
//                     <div className="rounded-xl border border-blue-100 bg-blue-50/60 p-3 w-full">
//                       <div className="flex items-center justify-between">
//                         <span className="font-semibold text-sm">
//                           Attach PDFs (optional)
//                         </span>
//                         <button
//                           type="button"
//                           onClick={() => addYtPdf(i)}
//                           className="px-2 py-1 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold hover:bg-blue-200 transition"
//                         >
//                           + Add PDF
//                         </button>
//                       </div>

//                       {pdfs.length === 0 && (
//                         <div className="text-xs text-gray-500 mt-2">
//                           No PDFs attached to this video yet.
//                         </div>
//                       )}

//                       {pdfs.map((p, j) => (
//                         <div
//                           key={j}
//                           className="mt-3 flex flex-col gap-2 bg-white rounded-lg p-3 border"
//                         >
//                           <div className="flex items-center gap-3 w-full">
//                             <input
//                               type="url"
//                               className="flex-1 p-2 border rounded-xl"
//                               placeholder="https://drive.google.com/file/d/..."
//                               value={p.url}
//                               onChange={(e) =>
//                                 changeYtPdf(i, j, "url", e.target.value)
//                               }
//                               required
//                             />

//                             <label className="flex items-center gap-1 text-[11px]">
//                               <input
//                                 type="radio"
//                                 name={`ytpdf-opt-${i}-${j}`}
//                                 checked={!!p.downloadable}
//                                 onChange={() => {
//                                   changeYtPdf(i, j, "downloadable", true);
//                                   changeYtPdf(i, j, "previewable", false);
//                                 }}
//                                 className="accent-blue-600"
//                               />
//                               Download
//                             </label>
//                             <label className="flex items-center gap-1 text-[11px]">
//                               <input
//                                 type="radio"
//                                 name={`ytpdf-opt-${i}-${j}`}
//                                 checked={!!p.previewable}
//                                 onChange={() => {
//                                   changeYtPdf(i, j, "previewable", true);
//                                   changeYtPdf(i, j, "downloadable", false);
//                                 }}
//                                 className="accent-green-600"
//                               />
//                               Preview
//                             </label>

//                             <label className="flex items-center gap-1 text-[11px] ml-1">
//                               <input
//                                 type="radio"
//                                 name={`ytpdf-access-${i}-${j}`}
//                                 checked={!!p.showFree}
//                                 onChange={() =>
//                                   changeYtPdf(i, j, "showFree", true)
//                                 }
//                                 className="accent-blue-600"
//                               />
//                               Free
//                             </label>
//                             <label className="flex items-center gap-1 text-[11px]">
//                               <input
//                                 type="radio"
//                                 name={`ytpdf-access-${i}-${j}`}
//                                 checked={!p.showFree}
//                                 onChange={() =>
//                                   changeYtPdf(i, j, "showFree", false)
//                                 }
//                                 className="accent-green-600"
//                               />
//                               After Paid
//                             </label>

//                             <button
//                               type="button"
//                               onClick={() => removeYtPdf(i, j)}
//                               className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1 text-lg"
//                               title="Remove PDF"
//                             >
//                               ×
//                             </button>
//                           </div>

//                           <div>
//                             <label className="font-semibold text-xs mb-1 block">
//                               Notes
//                             </label>
//                             <MDEditor
//                               value={p.notes || ""}
//                               onChange={(val) =>
//                                 changeYtPdf(i, j, "notes", val)
//                               }
//                               height={100}
//                               placeholder="Add notes for this PDF."
//                             />
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 );
//               })}

//               <button
//                 type="button"
//                 onClick={handleAddLink}
//                 className="w-fit px-3 py-1 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs mt-2"
//               >
//                 + Add YouTube Link
//               </button>
//             </div>
//           </>
//         ) : (
//           <>
//             {/* ================= PRODUCT: IMAGES (Drive) ================= */}
//             <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
//               <div className="text-lg font-bold mb-1">
//                 Product Images (Google Drive)
//               </div>
//               <div className="text-sm text-blue-700 mb-2">
//                 Paste Drive file links (set sharing to “Anyone with the link”).
//                 Choose one as <b>Main</b>.
//               </div>

//               {productImages.map((img, i) => (
//                 <div
//                   key={i}
//                   className="w-full bg-white rounded-xl px-4 py-3 mt-3 shadow"
//                 >
//                   <div className="flex items-center gap-3">
//                     <input
//                       type="url"
//                       className="flex-1 p-2 border rounded-xl"
//                       placeholder="https://drive.google.com/file/d/..."
//                       value={img.url}
//                       onChange={(e) =>
//                         changeProductImage(i, "url", e.target.value.trim())
//                       }
//                       required
//                     />
//                     <label className="flex items-center gap-1 text-xs whitespace-nowrap">
//                       <input
//                         type="radio"
//                         name="product-main-image"
//                         checked={!!img.isMain}
//                         onChange={() => setMainProductImage(i)}
//                         className="accent-blue-600"
//                       />
//                       Main
//                     </label>
//                     <button
//                       type="button"
//                       onClick={() => removeProductImage(i)}
//                       className="text-red-400 hover:bg-red-100 rounded-full p-2 text-lg"
//                       title="Remove image"
//                     >
//                       ×
//                     </button>
//                   </div>

//                   {img.url ? (
//                     <DriveImagePreview url={img.url} size="sm" />
//                   ) : null}
//                 </div>
//               ))}

//               <button
//                 type="button"
//                 className="mt-4 px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
//                 onClick={addProductImage}
//               >
//                 + Add Image
//               </button>
//             </div>

//             {/* ================= PRODUCT: MAIN DESCRIPTION ================= */}
//             <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
//               <div className="text-lg font-bold mb-2">Main Description</div>
//               <MDEditor
//                 value={productMainDesc}
//                 onChange={changeMainDesc}
//                 height={180}
//                 placeholder="Full product details, specs, what buyers get, etc."
//               />
//             </div>

//             {/* ================= PRODUCT: SUB DESCRIPTIONS ================= */}
//             <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
//               <div className="flex items-center justify-between mb-2">
//                 <div className="text-lg font-bold">Sub Descriptions</div>
//                 <button
//                   type="button"
//                   onClick={addSubDesc}
//                   className="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold hover:bg-blue-200 transition"
//                 >
//                   + Add bullet
//                 </button>
//               </div>
//               {productSubDescs.length === 0 && (
//                 <div className="text-xs text-gray-500">
//                   No sub descriptions yet.
//                 </div>
//               )}
//               {productSubDescs.map((d, i) => (
//                 <div
//                   key={i}
//                   className="flex items-center gap-2 bg-white rounded-xl px-3 py-2 mt-2 border"
//                 >
//                   <input
//                     className="flex-1 p-2 rounded-lg border bg-white"
//                     placeholder="e.g. 2-year warranty"
//                     value={d}
//                     onChange={(e) => changeSubDesc(i, e.target.value)}
//                   />
//                   <button
//                     type="button"
//                     className="text-red-400 hover:bg-red-100 rounded-full p-2"
//                     onClick={() => removeSubDesc(i)}
//                     title="Remove"
//                   >
//                     ×
//                   </button>
//                 </div>
//               ))}
//             </div>

//             {/* ================= PRODUCT: YOUTUBE (optional) ================= */}
//             <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-2xl p-4 mb-6">
//               <div className="font-bold text-lg mb-2">
//                 YouTube Links (optional)
//               </div>
//               {productYtLinks.map((l, i) => {
//                 const vid = getYouTubeVideoId(l.url);
//                 const ytThumb = vid
//                   ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
//                   : null;
//                 return (
//                   <div
//                     key={i}
//                     className="flex flex-col gap-2 bg-white rounded-xl px-4 py-3 mb-2 border"
//                   >
//                     <div className="flex items-center gap-2">
//                       <input
//                         className="flex-1 p-2 border rounded-xl bg-white"
//                         placeholder="https://youtube.com/..."
//                         value={l.url}
//                         onChange={(e) =>
//                           changeProductYt(i, "url", e.target.value)
//                         }
//                       />
//                       {ytThumb ? (
//                         <img
//                           src={ytThumb}
//                           alt="YT Thumb"
//                           className="w-10 h-10 object-cover rounded border"
//                         />
//                       ) : (
//                         <span className="ml-2 text-blue-400 text-xs">
//                           No thumbnail
//                         </span>
//                       )}
//                       <button
//                         type="button"
//                         className="text-red-400 hover:bg-red-100 rounded-full p-2"
//                         onClick={() => removeProductYt(i)}
//                         title="Remove"
//                       >
//                         ×
//                       </button>
//                     </div>
//                     <div>
//                       <label className="font-semibold text-xs mb-1 block">
//                         Notes
//                       </label>
//                       <MDEditor
//                         value={l.notes || ""}
//                         onChange={(val) => changeProductYt(i, "notes", val)}
//                         height={90}
//                         placeholder="Key points, how-to, etc."
//                       />
//                     </div>
//                   </div>
//                 );
//               })}
//               <button
//                 type="button"
//                 onClick={addProductYt}
//                 className="w-fit px-3 py-1 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs mt-2"
//               >
//                 + Add YouTube Link
//               </button>
//             </div>
//           </>
//         )}

//         {/* ================= NAV ================= */}
//         <div className="sticky bottom-0 bg-white/90 backdrop-blur border-t pt-2">
//           <div className="flex gap-2 justify-end">
//             <button
//               type="button"
//               className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
//               onClick={onBack}
//             >
//               Back
//             </button>
//             <button
//               type="submit"
//               className="px-6 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default StepUploadContent;

import { useState, useEffect } from "react";
import MDEditor from "@uiw/react-md-editor";

/* ----------------------- Drive helpers + preview ----------------------- */
function normalizeUrlList(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((it) =>
    typeof it === "string" ? { url: it } : it || { url: "" }
  );
}

function extractDriveId(url = "") {
  if (!url) return null;
  return (
    url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/)?.[1] ||
    url.match(/[?&]id=([a-zA-Z0-9_-]+)/)?.[1] ||
    url.match(/\/uc\?.*?[?&]id=([a-zA-Z0-9_-]+)/)?.[1]
  );
}
function getDrivePreviewUrl(url = "") {
  const id = extractDriveId(url);
  return id ? `https://drive.google.com/uc?export=view&id=${id}` : "";
}
function isDriveUrl(url = "") {
  return !!extractDriveId(url);
}
function DriveImagePreview({ url, size = "md" }) {
  const [state, setState] = useState("loading");
  const [src, setSrc] = useState(getDrivePreviewUrl(url));

  useEffect(() => {
    const next = getDrivePreviewUrl(url);
    setSrc(next);
    setState(next ? "loading" : "error");
  }, [url]);

  const handleError = () => {
    const id = extractDriveId(url);
    if (id && !String(src || "").includes("/thumbnail")) {
      setSrc(`https://drive.google.com/thumbnail?id=${id}&sz=w1000`);
      setState("loading");
    } else {
      setState("error");
    }
  };

  const cls =
    size === "sm"
      ? "w-28 h-28 object-cover rounded border"
      : "w-full max-w-md max-h-64 object-contain rounded-xl border";

  if (state === "error") {
    return (
      <p className="text-xs text-red-500 mt-1">
        Couldn’t load the image. Ensure it’s shared as{" "}
        <b>“Anyone with the link”</b>.
      </p>
    );
  }

  return (
    <img
      src={src}
      alt="Preview"
      className={cls}
      referrerPolicy="no-referrer"
      onLoad={() => setState("ok")}
      onError={handleError}
      loading="lazy"
    />
  );
}

function ImagePreview({ url, size = "md" }) {
  if (!url) return null;

  if (isDriveUrl(url)) {
    return <DriveImagePreview url={url} size={size} />;
  }

  const cls =
    size === "sm"
      ? "w-28 h-28 object-cover rounded border"
      : "w-full max-w-md max-h-64 object-contain rounded-xl border";

  return (
    <img
      src={url}
      alt="Preview"
      className={cls}
      loading="lazy"
    />
  );
}

/* --------------------------- YouTube helpers --------------------------- */
function getYouTubeVideoId(url) {
  if (!url) return null;
  const reg = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(reg);
  return match ? match[1] : null;
}

function prettyFileSize(bytes = 0) {
  const size = Number(bytes || 0);
  if (!size) return "";
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

/* ============================== Component ============================== */
export default function StepUploadContent({
  type,
  values,
  onChange,
  onNext,
  onBack,
}) {
  const t = (type || "").toLowerCase();
  const isProduct = t === "product";
  const isCourse = t === "course";
  const isService = t === "service";

  // --- normalize incoming arrays (and migrate from old shapes) ---
  const normalizedCourseImages = normalizeUrlList(values.courseImages);
  const normalizedProductImages = normalizeUrlList(
    values.productImages ?? values.images
  );
  const normalizedServiceImages = normalizeUrlList(values.serviceImages);

  useEffect(() => {
    const needsCourseFix =
      Array.isArray(values.courseImages) &&
      values.courseImages.some((x) => typeof x === "string");
    const needsProductFix =
      (Array.isArray(values.productImages) &&
        values.productImages.some((x) => typeof x === "string")) ||
      (!values.productImages && Array.isArray(values.images));
    const needsServiceFix =
      Array.isArray(values.serviceImages) &&
      values.serviceImages.some((x) => typeof x === "string");

    if (needsCourseFix || needsProductFix || needsServiceFix) {
      onChange({
        ...values,
        courseImages: needsCourseFix
          ? normalizeUrlList(values.courseImages)
          : normalizedCourseImages,
        productImages: needsProductFix
          ? normalizeUrlList(values.productImages ?? values.images)
          : normalizedProductImages,
        serviceImages: needsServiceFix
          ? normalizeUrlList(values.serviceImages)
          : normalizedServiceImages,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ------------------------ COURSE: Image links (Drive) ------------------------ */
  const courseImages = normalizedCourseImages;
  const addCourseImage = () =>
    onChange({ ...values, courseImages: [...courseImages, { url: "" }] });
  const changeCourseImage = (i, val) => {
    const arr = [...courseImages];
    arr[i] = { ...arr[i], url: val };
    onChange({ ...values, courseImages: arr });
  };
  const removeCourseImage = (i) => {
    const arr = [...courseImages];
    arr.splice(i, 1);
    onChange({ ...values, courseImages: arr });
  };

  /* ------------------------ COURSE: Global PDFs ------------------------ */
  const pdfLinks = Array.isArray(values.pdfLinks) ? values.pdfLinks : [];
  const handleAddPdfLink = () =>
    onChange({
      ...values,
      pdfLinks: [
        ...pdfLinks,
        {
          url: "",
          downloadable: false,
          previewable: false,
          showFree: false,
          notes: "",
        },
      ],
    });
  const handlePdfLinkChange = (i, key, val) => {
    const arr = [...pdfLinks];
    arr[i][key] = val;
    onChange({ ...values, pdfLinks: arr });
  };
  const handleRemovePdfLink = (i) => {
    const arr = [...pdfLinks];
    arr.splice(i, 1);
    onChange({ ...values, pdfLinks: arr });
  };

  /* ----------------------- COURSE: YouTube links ----------------------- */
  const ytLinks = Array.isArray(values.youtubeLinks) ? values.youtubeLinks : [];
  const handleAddLink = () =>
    onChange({
      ...values,
      youtubeLinks: [
        ...ytLinks,
        { url: "", showFree: false, notes: "", pdfs: [], topic: "" },
      ],
    });
  const handleLinkChange = (i, key, val) => {
    const arr = [...ytLinks];
    arr[i][key] = val;
    onChange({ ...values, youtubeLinks: arr });
  };
  const handleRemoveLink = (i) => {
    const arr = [...ytLinks];
    arr.splice(i, 1);
    onChange({ ...values, youtubeLinks: arr });
  };

  /* --------------- COURSE: PDFs attached to each YT link -------------- */
  const addYtPdf = (i) => {
    const arr = [...ytLinks];
    const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
    pdfs.push({
      url: "",
      downloadable: false,
      previewable: false,
      showFree: false,
      notes: "",
    });
    arr[i].pdfs = pdfs;
    onChange({ ...values, youtubeLinks: arr });
  };
  const changeYtPdf = (i, j, key, val) => {
    const arr = [...ytLinks];
    const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
    pdfs[j][key] = val;
    arr[i].pdfs = pdfs;
    onChange({ ...values, youtubeLinks: arr });
  };
  const removeYtPdf = (i, j) => {
    const arr = [...ytLinks];
    const pdfs = Array.isArray(arr[i].pdfs) ? arr[i].pdfs : [];
    pdfs.splice(j, 1);
    arr[i].pdfs = pdfs;
    onChange({ ...values, youtubeLinks: arr });
  };

  /* -------------------------- PRODUCT: Images -------------------------- */
  const productImages = normalizedProductImages.map((img, idx, all) => {
    if (typeof img.isMain !== "boolean") {
      const hasAnyMain = all.some((x) => x && x.isMain);
      return { ...img, isMain: hasAnyMain ? !!img.isMain : idx === 0 };
    }
    return img;
  });
  const addProductImage = () => {
    const next = [
      ...productImages,
      { url: "", isMain: productImages.length === 0, source: "link" },
    ];
    onChange({ ...values, productImages: next });
  };
  const changeProductImage = (i, key, val) => {
    const arr = [...productImages];
    arr[i] = { ...arr[i], [key]: val };
    onChange({ ...values, productImages: arr });
  };
  const removeProductImage = (i) => {
    const arr = [...productImages];
    const removed = arr.splice(i, 1)[0];
    if (removed?.isMain && arr.length > 0 && !arr.some((x) => x.isMain)) {
      arr[0].isMain = true;
    }
    onChange({ ...values, productImages: arr, detailImageIndexes: (values.detailImageIndexes || []).filter(index => index !== i).map(index => index > i ? index - 1 : index) });
  };
  const setMainProductImage = (i) => {
    const arr = productImages.map((img, idx) => ({
      ...img,
      isMain: idx === i,
    }));
    onChange({ ...values, productImages: arr });
  };
  const addProductFiles = (files) => {
    const selected = Array.from(files || []).filter((file) =>
      String(file?.type || "").startsWith("image/")
    );
    if (!selected.length) return;
    const hasMain = productImages.some((img) => img.isMain);
    const next = [
      ...productImages,
      ...selected.map((file, idx) => ({
        url: URL.createObjectURL(file),
        isMain: !hasMain && productImages.length === 0 && idx === 0,
        file,
        fileName: file.name || "",
        fileSize: file.size || 0,
        source: "upload",
      })),
    ];
    onChange({ ...values, productImages: next });
  };
  const handleProductFileInput = (e) => {
    addProductFiles(e.target.files);
    e.target.value = "";
  };

  /* -------------------- PRODUCT: Descriptions / YT -------------------- */
  const productMainDesc = values.productMainDesc || "";
  const productSubDescs = Array.isArray(values.productSubDescs)
    ? values.productSubDescs
    : [];
  const productYtLinks = Array.isArray(values.productYoutubeLinks)
    ? values.productYoutubeLinks
    : [];

  const changeMainDesc = (val) =>
    onChange({ ...values, productMainDesc: val || "" });
  const addSubDesc = () =>
    onChange({ ...values, productSubDescs: [...productSubDescs, ""] });
  const changeSubDesc = (i, val) => {
    const arr = [...productSubDescs];
    arr[i] = val;
    onChange({ ...values, productSubDescs: arr });
  };
  const removeSubDesc = (i) => {
    const arr = [...productSubDescs];
    arr.splice(i, 1);
    onChange({ ...values, productSubDescs: arr });
  };

  const addProductYt = () =>
    onChange({
      ...values,
      productYoutubeLinks: [...productYtLinks, { url: "", notes: "" }],
    });
  const changeProductYt = (i, key, val) => {
    const arr = [...productYtLinks];
    arr[i][key] = val;
    onChange({ ...values, productYoutubeLinks: arr });
  };
  const removeProductYt = (i) => {
    const arr = [...productYtLinks];
    arr.splice(i, 1);
    onChange({ ...values, productYoutubeLinks: arr });
  };

  /* -------------------------- SERVICE: Images -------------------------- */
  const serviceImages = normalizedServiceImages;
  const addServiceImage = () =>
    onChange({ ...values, serviceImages: [...serviceImages, { url: "" }] });
  const changeServiceImage = (i, val) => {
    const arr = [...serviceImages];
    arr[i] = { ...arr[i], url: val };
    onChange({ ...values, serviceImages: arr });
  };
  const removeServiceImage = (i) => {
    const arr = [...serviceImages];
    arr.splice(i, 1);
    onChange({ ...values, serviceImages: arr });
  };

  /* ---------------------- SERVICE: Deliverables list ---------------------- */
  const deliverables = Array.isArray(values.serviceDeliverables)
    ? values.serviceDeliverables
    : [];
  const addDeliverable = () =>
    onChange({ ...values, serviceDeliverables: [...deliverables, ""] });
  const changeDeliverable = (i, val) => {
    const arr = [...deliverables];
    arr[i] = val;
    onChange({ ...values, serviceDeliverables: arr });
  };
  const removeDeliverable = (i) => {
    const arr = [...deliverables];
    arr.splice(i, 1);
    onChange({ ...values, serviceDeliverables: arr });
  };

  /* --------------------------- SERVICE: FAQs --------------------------- */
  const faqs = Array.isArray(values.serviceFaqs) ? values.serviceFaqs : [];
  const addFaq = () =>
    onChange({ ...values, serviceFaqs: [...faqs, { q: "", a: "" }] });
  const changeFaq = (i, key, val) => {
    const arr = [...faqs];
    arr[i] = { ...(arr[i] || {}), [key]: val };
    onChange({ ...values, serviceFaqs: arr });
  };
  const removeFaq = (i) => {
    const arr = [...faqs];
    arr.splice(i, 1);
    onChange({ ...values, serviceFaqs: arr });
  };

  /* ---------------------- SERVICE: YouTube (optional) ---------------------- */
  const serviceYtLinks = Array.isArray(values.serviceYoutubeLinks)
    ? values.serviceYoutubeLinks
    : [];
  const addServiceYt = () =>
    onChange({
      ...values,
      serviceYoutubeLinks: [...serviceYtLinks, { url: "", notes: "" }],
    });
  const changeServiceYt = (i, key, val) => {
    const arr = [...serviceYtLinks];
    arr[i][key] = val;
    onChange({ ...values, serviceYoutubeLinks: arr });
  };
  const removeServiceYt = (i) => {
    const arr = [...serviceYtLinks];
    arr.splice(i, 1);
    onChange({ ...values, serviceYoutubeLinks: arr });
  };

  /* ----------------------------- Validate ----------------------------- */
  function handleNext(e) {
    e.preventDefault();

    if (isProduct) {
      const hasVariationImage = values.variants?.some(v => v.images?.some(image => typeof image === "string" ? !!image : !!image?.url || image?.file instanceof File));
      if (productImages.length === 0 && !hasVariationImage) {
        alert("Please add at least one product image.");
        return;
      }
      if (productImages.some((img) => !img?.url && !(img?.file instanceof File))) {
        alert("Please remove empty product image rows or add an image.");
        return;
      }
      if (productImages.length > 0 && !productImages.some((img) => img.isMain)) {
        alert("Please select a main image.");
        return;
      }
      if (!values.productMainDesc || values.productMainDesc.trim() === "") {
        alert("Please add a main description for your product.");
        return;
      }
      onNext();
      return;
    }

    if (isCourse) {
      const totalGlobal = Array.isArray(pdfLinks) ? pdfLinks.length : 0;
      const totalVideo = ytLinks.reduce(
        (sum, l) => sum + (Array.isArray(l.pdfs) ? l.pdfs.length : 0),
        0
      );
      if (totalGlobal + totalVideo === 0) {
        alert("Please add at least one PDF (global or attached to a video).");
        return;
      }
      onNext();
      return;
    }

    if (isService) {
      const hasDeliverables =
        (Array.isArray(deliverables)
          ? deliverables.filter(Boolean).length
          : 0) > 0;
      if (!hasDeliverables) {
        alert("Please add at least one deliverable for this service.");
        return;
      }
      onNext();
      return;
    }
  }

  /* ------------------------------ Render ------------------------------ */
  return (
    <div className="max-h-[80vh] overflow-y-auto">
      <form className="flex flex-col gap-6" onSubmit={handleNext}>
        {isCourse && (
          <>
            {/* ================= COURSE: IMAGE LINKS ================= */}
            <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
              <span className="text-lg font-bold mb-1 block">
                Course Images (Google Drive)
              </span>
              <span className="text-sm text-blue-700 mb-2 block">
                Add any number of image links from Google Drive. Set each file’s
                sharing to <b>“Anyone with the link”</b>.
              </span>
              {courseImages.map((img, i) => (
                <div
                  key={i}
                  className="w-full bg-white rounded-xl px-4 py-3 mt-3 shadow"
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="url"
                      className="flex-1 p-2 border rounded-xl"
                      placeholder="https://drive.google.com/file/d/..."
                      value={img.url}
                      onChange={(e) =>
                        changeCourseImage(i, e.target.value.trim())
                      }
                      required
                    />
                    <button
                      type="button"
                      onClick={() => removeCourseImage(i)}
                      className="text-red-400 hover:bg-red-100 rounded-full p-2 text-lg"
                      title="Remove image"
                    >
                      ×
                    </button>
                  </div>
                  {img.url ? (
                    <DriveImagePreview url={img.url} size="sm" />
                  ) : null}
                </div>
              ))}
              <button
                type="button"
                className="mt-4 px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
                onClick={addCourseImage}
              >
                + Add Image
              </button>
            </div>

            {/* ================= COURSE: GLOBAL PDFs ================= */}
            <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
              <span className="text-lg font-bold mb-1 block">
                Add PDF Links (Google Drive)
              </span>
              <span className="text-sm text-blue-700 mb-2 block">
                Paste your PDF file link from Google Drive. Set file sharing to
                "Anyone with the link". Choose if each PDF is <b>Free</b> or
                shown <b>After Paid</b>.
              </span>
              {pdfLinks.map((p, i) => (
                <div
                  key={i}
                  className="w-full flex flex-col items-start gap-2 bg-white rounded-xl px-6 py-4 mt-3 shadow"
                >
                  <div className="flex items-center gap-4 w-full">
                    <input
                      type="url"
                      className="flex-1 p-2 border rounded-xl"
                      placeholder="https://drive.google.com/file/d/..."
                      value={p.url}
                      onChange={(e) =>
                        handlePdfLinkChange(i, "url", e.target.value)
                      }
                      required
                    />
                    <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                      <input
                        type="radio"
                        name={`pdfOption-${i}`}
                        checked={!!p.downloadable}
                        onChange={() => {
                          handlePdfLinkChange(i, "downloadable", true);
                          handlePdfLinkChange(i, "previewable", false);
                        }}
                        className="accent-blue-600"
                      />
                      Downloadable
                    </label>
                    <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                      <input
                        type="radio"
                        name={`pdfOption-${i}`}
                        checked={!!p.previewable}
                        onChange={() => {
                          handlePdfLinkChange(i, "previewable", true);
                          handlePdfLinkChange(i, "downloadable", false);
                        }}
                        className="accent-green-600"
                      />
                      Preview on site
                    </label>
                    <label className="flex items-center gap-1 text-xs whitespace-nowrap ml-2">
                      <input
                        type="radio"
                        name={`pdfAccess-${i}`}
                        checked={!!p.showFree}
                        onChange={() =>
                          handlePdfLinkChange(i, "showFree", true)
                        }
                        className="accent-blue-600"
                      />
                      Free
                    </label>
                    <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                      <input
                        type="radio"
                        name={`pdfAccess-${i}`}
                        checked={!p.showFree}
                        onChange={() =>
                          handlePdfLinkChange(i, "showFree", false)
                        }
                        className="accent-green-600"
                      />
                      After Paid
                    </label>
                    <button
                      type="button"
                      onClick={() => handleRemovePdfLink(i)}
                      className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1 text-lg"
                      title="Remove PDF Link"
                    >
                      ×
                    </button>
                  </div>
                  <div className="w-full mt-1 text-left">
                    <label className="font-semibold text-xs mb-1 block">
                      Notes
                    </label>
                    <MDEditor
                      value={p.notes || ""}
                      onChange={(val) => handlePdfLinkChange(i, "notes", val)}
                      height={120}
                      placeholder="Add notes, instructions, etc."
                    />
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="mt-4 px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
                onClick={handleAddPdfLink}
              >
                + Add PDF Link
              </button>
            </div>

            {/* ================= COURSE: YOUTUBE LINKS ================= */}
            <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-2xl p-4 mb-6">
              <div className="font-bold text-lg mb-2">YouTube Links</div>
              {ytLinks.map((link, i) => {
                const vid = getYouTubeVideoId(link.url);
                const ytThumb = vid
                  ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
                  : null;
                const pdfs = Array.isArray(link.pdfs) ? link.pdfs : [];
                return (
                  <div
                    key={i}
                    className="flex flex-col gap-3 bg-white rounded-xl px-4 py-3 mb-3 shadow-sm"
                  >
                    <label className="font-semibold text-xs block">Topic</label>
                    <input
                      value={link.topic}
                      placeholder="Topic"
                      onChange={(e) =>
                        handleLinkChange(i, "topic", e.target.value)
                      }
                      className="flex-1 p-2 border rounded-xl bg-white"
                    />
                    <label className="font-semibold text-xs mt-2 block">
                      YouTube Link
                    </label>
                    <div className="flex items-center gap-2 w-full">
                      <input
                        className="flex-1 p-2 border rounded-xl bg-white"
                        placeholder="https://youtube.com/..."
                        value={link.url}
                        onChange={(e) =>
                          handleLinkChange(i, "url", e.target.value)
                        }
                      />
                      <label className="flex items-center gap-1 ml-2">
                        <input
                          type="radio"
                          checked={!!link.showFree}
                          onChange={() => handleLinkChange(i, "showFree", true)}
                          className="accent-blue-600"
                        />
                        Free
                      </label>
                      <label className="flex items-center gap-1 ml-1">
                        <input
                          type="radio"
                          checked={!link.showFree}
                          onChange={() =>
                            handleLinkChange(i, "showFree", false)
                          }
                          className="accent-green-600"
                        />
                        After Paid
                      </label>
                      {ytThumb ? (
                        <img
                          src={ytThumb}
                          alt="YT Thumb"
                          className="w-10 h-10 object-cover rounded border"
                        />
                      ) : (
                        <span className="ml-2 text-blue-400 text-xs">
                          No thumbnail
                        </span>
                      )}
                      <button
                        type="button"
                        className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1"
                        title="Remove link"
                        onClick={() => handleRemoveLink(i)}
                      >
                        ×
                      </button>
                    </div>
                    <div className="w-full">
                      <label className="font-semibold text-xs mb-1 block">
                        Notes
                      </label>
                      <MDEditor
                        value={link.notes || ""}
                        onChange={(val) => handleLinkChange(i, "notes", val)}
                        height={100}
                        placeholder="Add video notes, key points, etc."
                      />
                    </div>
                    <div className="rounded-xl border border-blue-100 bg-blue-50/60 p-3 w-full">
                      <div className="flex items-center justify-between">
                        <span className="font-semibold text-sm">
                          Attach PDFs (optional)
                        </span>
                        <button
                          type="button"
                          onClick={() => addYtPdf(i)}
                          className="px-2 py-1 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold hover:bg-blue-200 transition"
                        >
                          + Add PDF
                        </button>
                      </div>
                      {pdfs.length === 0 && (
                        <div className="text-xs text-gray-500 mt-2">
                          No PDFs attached to this video yet.
                        </div>
                      )}
                      {pdfs.map((p, j) => (
                        <div
                          key={j}
                          className="mt-3 flex flex-col gap-2 bg-white rounded-lg p-3 border"
                        >
                          <div className="flex items-center gap-3 w-full">
                            <input
                              type="url"
                              className="flex-1 p-2 border rounded-xl"
                              placeholder="https://drive.google.com/file/d/..."
                              value={p.url}
                              onChange={(e) =>
                                changeYtPdf(i, j, "url", e.target.value)
                              }
                              required
                            />
                            <label className="flex items-center gap-1 text-[11px]">
                              <input
                                type="radio"
                                name={`ytpdf-opt-${i}-${j}`}
                                checked={!!p.downloadable}
                                onChange={() => {
                                  changeYtPdf(i, j, "downloadable", true);
                                  changeYtPdf(i, j, "previewable", false);
                                }}
                                className="accent-blue-600"
                              />
                              Download
                            </label>
                            <label className="flex items-center gap-1 text-[11px]">
                              <input
                                type="radio"
                                name={`ytpdf-opt-${i}-${j}`}
                                checked={!!p.previewable}
                                onChange={() => {
                                  changeYtPdf(i, j, "previewable", true);
                                  changeYtPdf(i, j, "downloadable", false);
                                }}
                                className="accent-green-600"
                              />
                              Preview
                            </label>
                            <label className="flex items-center gap-1 text-[11px] ml-1">
                              <input
                                type="radio"
                                name={`ytpdf-access-${i}-${j}`}
                                checked={!!p.showFree}
                                onChange={() =>
                                  changeYtPdf(i, j, "showFree", true)
                                }
                                className="accent-blue-600"
                              />
                              Free
                            </label>
                            <label className="flex items-center gap-1 text-[11px]">
                              <input
                                type="radio"
                                name={`ytpdf-access-${i}-${j}`}
                                checked={!p.showFree}
                                onChange={() =>
                                  changeYtPdf(i, j, "showFree", false)
                                }
                                className="accent-green-600"
                              />
                              After Paid
                            </label>
                            <button
                              type="button"
                              onClick={() => removeYtPdf(i, j)}
                              className="text-red-400 hover:bg-red-100 rounded-full p-2 ml-1 text-lg"
                              title="Remove PDF"
                            >
                              ×
                            </button>
                          </div>
                          <div>
                            <label className="font-semibold text-xs mb-1 block">
                              Notes
                            </label>
                            <MDEditor
                              value={p.notes || ""}
                              onChange={(val) =>
                                changeYtPdf(i, j, "notes", val)
                              }
                              height={100}
                              placeholder="Add notes for this PDF."
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                onClick={handleAddLink}
                className="w-fit px-3 py-1 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs mt-2"
              >
                + Add YouTube Link
              </button>
            </div>
          </>
        )}

        {isProduct && (
          <>
            {/* ================= PRODUCT: IMAGES ================= */}
            <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
              <div className="text-lg font-bold mb-1">
                Product Images
              </div>
              <div className="text-sm text-blue-700 mb-2">
                Upload images directly from your device, or paste an image link
                if you already host it somewhere. Choose one as <b>Main</b>.
              </div>
              <div className="rounded-2xl border border-blue-200 bg-white/80 p-4 mb-4">
                <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                  <div>
                    <div className="font-semibold text-gray-900">
                      Upload from device
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      JPG, PNG, WEBP and other image files are supported.
                    </div>
                  </div>
                  <label className="inline-flex cursor-pointer items-center justify-center rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700">
                    Choose images
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      className="hidden"
                      onChange={handleProductFileInput}
                    />
                  </label>
                </div>
              </div>
              {productImages.map((img, i) => (
                <div
                  key={i}
                  className="w-full bg-white rounded-xl px-4 py-3 mt-3 shadow"
                >
                  <div className="flex flex-col gap-3 md:flex-row md:items-center">
                    {img.source === "upload" ? (
                      <div className="flex-1 rounded-xl border bg-gray-50 px-3 py-2 text-sm text-gray-700">
                        Uploaded from device
                        {img.fileName ? `: ${img.fileName}` : ""}
                      </div>
                    ) : (
                      <input
                        type="text"
                        className="flex-1 p-2 border rounded-xl"
                        placeholder="Paste image link"
                        value={img.url}
                        onChange={(e) =>
                          changeProductImage(i, "url", e.target.value.trim())
                        }
                      />
                    )}
                    <label className="flex items-center gap-1 text-xs whitespace-nowrap">
                      <input
                        type="radio"
                        name="product-main-image"
                        checked={!!img.isMain}
                        onChange={() => setMainProductImage(i)}
                        className="accent-blue-600"
                      />
                      Main
                    </label>
                    <button
                      type="button"
                      onClick={() => removeProductImage(i)}
                      className="text-red-400 hover:bg-red-100 rounded-full p-2 text-lg"
                      title="Remove image"
                    >
                      ×
                    </button>
                  </div>
                  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-gray-500">
                    {img.source === "upload" ? (
                      <span className="rounded-full bg-emerald-50 px-2 py-1 text-emerald-700">
                        Uploaded file{img.fileName ? `: ${img.fileName}` : ""}
                        {img.fileSize ? ` • ${prettyFileSize(img.fileSize)}` : ""}
                      </span>
                    ) : (
                      <span className="rounded-full bg-blue-50 px-2 py-1 text-blue-700">
                        External image link
                      </span>
                    )}
                  </div>
                  {img.url ? (
                    <ImagePreview url={img.url} size="sm" />
                  ) : null}
                </div>
              ))}
              <div className="mt-4 flex flex-wrap gap-2">
                <label className="inline-flex cursor-pointer items-center justify-center rounded-xl border border-blue-200 bg-white px-4 py-2 text-xs font-semibold text-blue-700 hover:bg-blue-50">
                  + Add more uploads
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    className="hidden"
                    onChange={handleProductFileInput}
                  />
                </label>
                <button
                  type="button"
                  className="px-4 py-2 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs"
                  onClick={addProductImage}
                >
                  + Add image link
                </button>
              </div>
            </div>

            {/* ================= PRODUCT: MAIN DESCRIPTION ================= */}
            <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
              <div className="text-lg font-bold mb-2">Main Description</div>
              <MDEditor
                value={productMainDesc}
                onChange={changeMainDesc}
                height={180}
                placeholder="Full product details, specs, what buyers get, etc."
              />
            </div>

            {/* ================= PRODUCT: SUB DESCRIPTIONS ================= */}
            <div className="rounded-2xl border-2 border-dashed border-blue-200 p-4 bg-blue-50">
              <div className="flex items-center justify-between mb-2">
                <div className="text-lg font-bold">Quick Highlights</div>
                <button
                  type="button"
                  onClick={addSubDesc}
                  className="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 text-xs font-semibold hover:bg-blue-200 transition"
                >
                  + Add bullet
                </button>
              </div>
              {productSubDescs.length === 0 && (
                <div className="text-xs text-gray-500">
                  Add short bullets like warranty, color, delivery speed, or key benefits.
                </div>
              )}
              {productSubDescs.map((d, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-white rounded-xl px-3 py-2 mt-2 border"
                >
                  <input
                    className="flex-1 p-2 rounded-lg border bg-white"
                    placeholder="e.g. 2-year warranty"
                    value={d}
                    onChange={(e) => changeSubDesc(i, e.target.value)}
                  />
                  <button
                    type="button"
                    className="text-red-400 hover:bg-red-100 rounded-full p-2"
                    onClick={() => removeSubDesc(i)}
                    title="Remove"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            {/* ================= PRODUCT: YOUTUBE (optional) ================= */}
            <div className="bg-blue-50 border-2 border-dashed border-blue-200 rounded-2xl p-4 mb-6">
              <div className="font-bold text-lg mb-2">
                YouTube Links (optional)
              </div>
              {productYtLinks.map((l, i) => {
                const vid = getYouTubeVideoId(l.url);
                const ytThumb = vid
                  ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
                  : null;
                return (
                  <div
                    key={i}
                    className="flex flex-col gap-2 bg-white rounded-xl px-4 py-3 mb-2 border"
                  >
                    <div className="flex items-center gap-2">
                      <input
                        className="flex-1 p-2 border rounded-xl bg-white"
                        placeholder="https://youtube.com/..."
                        value={l.url}
                        onChange={(e) =>
                          changeProductYt(i, "url", e.target.value)
                        }
                      />
                      {ytThumb ? (
                        <img
                          src={ytThumb}
                          alt="YT Thumb"
                          className="w-10 h-10 object-cover rounded border"
                        />
                      ) : (
                        <span className="ml-2 text-blue-400 text-xs">
                          No thumbnail
                        </span>
                      )}
                      <button
                        type="button"
                        className="text-red-400 hover:bg-red-100 rounded-full p-2"
                        onClick={() => removeProductYt(i)}
                        title="Remove"
                      >
                        ×
                      </button>
                    </div>
                    <div>
                      <label className="font-semibold text-xs mb-1 block">
                        Notes
                      </label>
                      <MDEditor
                        value={l.notes || ""}
                        onChange={(val) => changeProductYt(i, "notes", val)}
                        height={90}
                        placeholder="Key points, how-to, etc."
                      />
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                onClick={addProductYt}
                className="w-fit px-3 py-1 rounded-xl bg-blue-100 text-blue-700 font-semibold hover:bg-blue-200 transition text-xs mt-2"
              >
                + Add YouTube Link
              </button>
            </div>
          </>
        )}

        {isService && (
          <>
            {/* ================= SERVICE: IMAGES ================= */}
            <div className="rounded-2xl border-2 border-dashed border-emerald-200 p-4 bg-emerald-50">
              <div className="text-lg font-bold mb-1">
                Service Gallery (Google Drive)
              </div>
              <div className="text-sm text-emerald-700 mb-2">
                Add examples, portfolios, or mockups. Share files as “Anyone
                with the link”.
              </div>
              {serviceImages.map((img, i) => (
                <div
                  key={i}
                  className="w-full bg-white rounded-xl px-4 py-3 mt-3 shadow"
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="url"
                      className="flex-1 p-2 border rounded-xl"
                      placeholder="https://drive.google.com/file/d/..."
                      value={img.url}
                      onChange={(e) =>
                        changeServiceImage(i, e.target.value.trim())
                      }
                      required
                    />
                    <button
                      type="button"
                      onClick={() => removeServiceImage(i)}
                      className="text-red-400 hover:bg-red-100 rounded-full p-2 text-lg"
                      title="Remove image"
                    >
                      ×
                    </button>
                  </div>
                  {img.url ? (
                    <DriveImagePreview url={img.url} size="sm" />
                  ) : null}
                </div>
              ))}
              <button
                type="button"
                className="mt-4 px-4 py-2 rounded-xl bg-emerald-100 text-emerald-700 font-semibold hover:bg-emerald-200 transition text-xs"
                onClick={addServiceImage}
              >
                + Add Image
              </button>
            </div>

            {/* ================= SERVICE: DELIVERABLES ================= */}
            <div className="rounded-2xl border-2 border-dashed border-emerald-200 p-4 bg-emerald-50">
              <div className="flex items-center justify-between mb-2">
                <div className="text-lg font-bold">Deliverables</div>
                <button
                  type="button"
                  onClick={addDeliverable}
                  className="px-3 py-1 rounded-lg bg-emerald-100 text-emerald-700 text-xs font-semibold hover:bg-emerald-200 transition"
                >
                  + Add deliverable
                </button>
              </div>
              {deliverables.length === 0 && (
                <div className="text-xs text-gray-500">
                  List what the client will receive.
                </div>
              )}
              {deliverables.map((d, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-white rounded-xl px-3 py-2 mt-2 border"
                >
                  <input
                    className="flex-1 p-2 rounded-lg border bg-white"
                    placeholder="e.g. 5-page website, SEO setup, 2 revisions"
                    value={d}
                    onChange={(e) => changeDeliverable(i, e.target.value)}
                  />
                  <button
                    type="button"
                    className="text-red-400 hover:bg-red-100 rounded-full p-2"
                    onClick={() => removeDeliverable(i)}
                    title="Remove"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            {/* ================= SERVICE: FAQs ================= */}
            <div className="rounded-2xl border-2 border-dashed border-emerald-200 p-4 bg-emerald-50">
              <div className="flex items-center justify-between mb-2">
                <div className="text-lg font-bold">FAQs (optional)</div>
                <button
                  type="button"
                  onClick={addFaq}
                  className="px-3 py-1 rounded-lg bg-emerald-100 text-emerald-700 text-xs font-semibold hover:bg-emerald-200 transition"
                >
                  + Add FAQ
                </button>
              </div>
              {faqs.length === 0 && (
                <div className="text-xs text-gray-500">No FAQs yet.</div>
              )}
              {faqs.map((f, i) => (
                <div
                  key={i}
                  className="bg-white rounded-xl px-3 py-3 mt-2 border"
                >
                  <input
                    className="w-full p-2 rounded-lg border bg-white mb-2"
                    placeholder="Question"
                    value={f?.q || ""}
                    onChange={(e) => changeFaq(i, "q", e.target.value)}
                  />
                  <MDEditor
                    value={f?.a || ""}
                    onChange={(val) => changeFaq(i, "a", val)}
                    height={120}
                    placeholder="Answer"
                  />
                  <div className="flex justify-end mt-2">
                    <button
                      type="button"
                      className="text-red-400 hover:bg-red-100 rounded-full p-2"
                      onClick={() => removeFaq(i)}
                      title="Remove"
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* ================= SERVICE: YOUTUBE (optional) ================= */}
            <div className="bg-emerald-50 border-2 border-dashed border-emerald-200 rounded-2xl p-4 mb-6">
              <div className="font-bold text-lg mb-2">
                YouTube Links (optional)
              </div>
              {serviceYtLinks.map((l, i) => {
                const vid = getYouTubeVideoId(l.url);
                const ytThumb = vid
                  ? `https://img.youtube.com/vi/${vid}/mqdefault.jpg`
                  : null;
                return (
                  <div
                    key={i}
                    className="flex flex-col gap-2 bg-white rounded-xl px-4 py-3 mb-2 border"
                  >
                    <div className="flex items-center gap-2">
                      <input
                        className="flex-1 p-2 border rounded-xl bg-white"
                        placeholder="https://youtube.com/..."
                        value={l.url}
                        onChange={(e) =>
                          changeServiceYt(i, "url", e.target.value)
                        }
                      />
                      {ytThumb ? (
                        <img
                          src={ytThumb}
                          alt="YT Thumb"
                          className="w-10 h-10 object-cover rounded border"
                        />
                      ) : (
                        <span className="ml-2 text-emerald-500 text-xs">
                          No thumbnail
                        </span>
                      )}
                      <button
                        type="button"
                        className="text-red-400 hover:bg-red-100 rounded-full p-2"
                        onClick={() => removeServiceYt(i)}
                        title="Remove"
                      >
                        ×
                      </button>
                    </div>
                    <div>
                      <label className="font-semibold text-xs mb-1 block">
                        Notes
                      </label>
                      <MDEditor
                        value={l.notes || ""}
                        onChange={(val) => changeServiceYt(i, "notes", val)}
                        height={90}
                        placeholder="Scope notes, examples, etc."
                      />
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                onClick={addServiceYt}
                className="w-fit px-3 py-1 rounded-xl bg-emerald-100 text-emerald-700 font-semibold hover:bg-emerald-200 transition text-xs mt-2"
              >
                + Add YouTube Link
              </button>
            </div>
          </>
        )}

        {/* ================= NAV ================= */}
        <div className="sticky bottom-0 bg-white/90 backdrop-blur border-t pt-2">
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              className="px-4 py-2 rounded-xl bg-gray-100 text-gray-600"
              onClick={onBack}
            >
              Back
            </button>
            <button
              type="submit"
              className="px-6 py-2 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
